export default __webpack_public_path__ + "static/media/icon-coin-snx.1e252944.svg";